import { useEffect, useState } from "react";
import icon from "../../assets/app_icon.png";
import { goToHero } from "./shared";

const links = [
  { href: "#how", label: "How it works" },
  { href: "#lesson", label: "Lessons" },
  { href: "#research", label: "Research" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
];

/** `dark`: ink text, for the light part of the page. */
export function Logo({ dark }: { dark?: boolean }) {
  return (
    <a href="#top" className="flex items-center gap-2.5">
      <img src={icon} alt="" width={32} height={32} className="size-8 rounded-[9px]" />
      <span className={`text-lg font-black tracking-tight ${dark ? "text-[#1C1A27]" : "text-white"}`}>LearnAnything</span>
    </a>
  );
}

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  // past the dawn the page is daylight: the bar turns light to match
  const [day, setDay] = useState(false);
  useEffect(() => {
    const on = () => {
      setScrolled(scrollY > 24);
      const how = document.getElementById("how");
      setDay(!!how && scrollY > how.offsetTop - 64);
    };
    on();
    addEventListener("scroll", on, { passive: true });
    return () => removeEventListener("scroll", on);
  }, []);
  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${day ? "border-b-2 border-[#E7E3F0] bg-white/95 backdrop-blur-md" : scrolled ? "border-b border-white/[0.08] bg-[rgba(4,7,42,0.78)] backdrop-blur-md" : "border-b border-transparent"}`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Logo dark={day} />
        <nav aria-label="Sections" className={`hidden items-center gap-7 text-[15px] font-bold md:flex ${day ? "text-[#6B6780]" : "text-[rgba(220,215,255,0.7)]"}`}>
          {links.map(l => (
            <a key={l.href} href={l.href} className={day ? "hover:text-[#1C1A27]" : "hover:text-white"}>
              {l.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          onClick={goToHero}
          className="inline-flex h-9 items-center rounded-xl border-b-[3px] border-[#4128B8] bg-brand px-4 text-sm font-black text-white hover:brightness-110"
        >
          Start learning
        </button>
      </div>
    </header>
  );
}
